import { Urls } from '../../../Shared/Api';

export default class ReviewsCarouselService {
    static getReviews() {
        return fetch(Urls.reviews.getGooglePlaceData)
            .then((res) => {
                return res.json();
            });
    }
}


// WEBPACK FOOTER //
// ./Src/Components/GoogleReviews/GoogleReviewsCarousel/GoogleReviewsCarouselService.js